/**
* @name APP parvulo
* @description
* # name controller --> coresCreateController
* # As Controller --> coresCreate
* brief comment controller creation levels users
*/

export default class coresCreateController {
  	constructor($scope,coresServices,ambitsServices,ngNotify,UserInfoConstant,$state,$filter) {
		this.$scope = $scope
		this.ngNotify = ngNotify
		this.$state = $state
		this.ambitsServices = ambitsServices.services
		this.services   = coresServices.services
		this.$scope.grid = false
		this.$translate = $filter('translate');
        this.conceptId = 0
		this.$scope.ambitSelect = null
		this.$scope.name = null
		this.ambitId = null
		
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});
   	}

	init(){
		this.getAmbits()
	}

	getAmbits(){
		this.ambitsServices.getAmbits().$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.ambits = []
				this.ambitsList = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	beforeSave(){
		if(this.$scope.name === null) {
			this.ngNotify.set('Indique nombre','warn')
			return
		}

		if(this.ambitId === null) {
			this.ngNotify.set('Seleccione un Ambito','warn')
			return
		}		

		this.$scope.isDisabled = true;
		let params  = { 
			name   : this.$scope.name,
			user_id : this.user_id,
			concept_id: this.conceptId,
			ambit_id: this.ambitId
		}

		this.save(params)
	}

	selectChanged(ambitSelect){
		this.ambitId = ambitSelect

	}

	save(params){
		this.services.saveCores(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha creado el Núcleo correctamente','success');
				this.$state.go("app.cores");
			}else{
				this.ngNotify.set('Error con servicio check request','error');
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de núcleo ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})
	}
}
coresCreateController.$inject=['$scope', 'coresServices', 'ambitsServices', 'ngNotify','UserInfoConstant','$state','$filter']








// WEBPACK FOOTER //
// ./src/app/admin-panel/cores/create/coresCreateController.js